import React from 'react';
import { Container, Chip } from '@infoods/lifebase-ui';

import classes from './NgzChallengePreview.module.scss';
import { SwymoHeader } from '../../../shared/components/header-components/SwymoHeader/SwymoHeader';
import { angularizeWithProviders } from '../../../shared/providers';

import { ChallengeLandingContent } from '../../containers/ChallengeLandingContent/ChallengeLandingContent';
import { useChallengeInfo } from '../../hooks/useChallengeInfo';
import { privateChallengeInfoService } from '../../services/challenge-info/privateChallengeInfoService';
import { getRouteParam, goTo } from '../../../shared/utils/angularUtils';
import { CHALLENGE_STATUS } from '../../constants/challengeStatus';
import { ErrorState } from '../../../shared/components/ErrorState/ErrorState';

const NgzChallengePreview = () => {
  const challengeId = getRouteParam('challengeId');

  const { challengeInfo, isNotFound } = useChallengeInfo({
    challengeId,
    getChallengeInfo: privateChallengeInfoService.getChallengeInfo,
  });

  if (isNotFound) {
    return (
      <ErrorState
        title="We couldn't find this page"
        description={
          <>
            Looks like the link might be incomplete or incorrect.
            <br />
            Please double-check the address and try again — or copy the full link from the
            original message.
          </>
        }
      />
    );
  }

  if (!challengeInfo) {
    return null;
  }

  if (challengeInfo.challenge.status !== CHALLENGE_STATUS.DRAFT) {
    goTo(`/challenge-landing/${challengeId}`, { replaceHistory: true });
  }

  return (
    <>
      <SwymoHeader inAngularContainer />
      <Container maxWidth="md">
        <ChallengeLandingContent
          challengeInfo={challengeInfo}
          headerBlock={
            <Chip
              className={classes.draftChip}
              size="small"
              color="info"
              label="Draft. Needs to be published"
            />
          }
        />
      </Container>
    </>
  );
};

angularizeWithProviders(NgzChallengePreview, 'ngzChallengePreview', {});
